import React, { useEffect, useState } from 'react';
import { FiLogOut } from "react-icons/fi";
import { getModuleLeaders } from '../../api/adminApi';

// --- Header Component ---
const Header = ({ user, handleLogout, onLeaderSelect }) => {
  const ALLOW_DROPDOWN = false; // Set to true to enable leader dropdown selection
  const [leaders, setLeaders] = useState([]);
  const [selectedLeaderId, setSelectedLeaderId] = useState(null);
  useEffect(() => {
    const fetchLeaders = async () => {
      if (!ALLOW_DROPDOWN || !user || !user.role || !user.role.toLowerCase().includes('leader')) {
        if (user?.role?.toLowerCase().includes('leader') && onLeaderSelect) {
          onLeaderSelect({ account_id: user.id, email: user.email, display_name: user.name });
        }
        return;
      }
      try {
        const data = await getModuleLeaders();
        setLeaders(data || []);

        // Try to auto-select if the logged-in user matches one of the leader accounts
        if (user?.email) {
          const match = (data || []).find(l => l.email === user.email);
          if (match) {
            setSelectedLeaderId(match.account_id);
            if (onLeaderSelect) onLeaderSelect(match);
          }
        }
      } catch (err) {
        console.error('Failed to fetch leaders:', err);
      }
    };
    fetchLeaders();
  }, [ALLOW_DROPDOWN, user, onLeaderSelect]);

  if (!user) return null; // Only show if user is logged in

  const handleLeaderChange = (e) => {
    const id = Number(e.target.value) || null;
    setSelectedLeaderId(id);
    const leader = leaders.find(l => l.account_id === id) || null;
    if (onLeaderSelect) onLeaderSelect(leader);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-10">
      <button
        onClick={handleLogout}
        className="lg:hidden fixed top-4 right-4 z-50 inline-flex items-center justify-center w-11 h-11 rounded-lg bg-red-600 text-white shadow hover:bg-red-700 transition"
        aria-label="Logout"
      >
        <FiLogOut size={20} className="rotate-180" />
      </button>

      <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8 flex flex-col items-center lg:flex-row lg:justify-between lg:items-center gap-3">
        <picture>
          <source media="(max-width: 1023px)" srcSet="/logo-small.svg" />
          <img
            src="/logo-text.svg"
            alt="SentinelEDU Logo"
            className="h-16 lg:h-16 w-auto"
          />
        </picture>
        <div className="hidden lg:flex w-full lg:w-auto flex-wrap items-center justify-center lg:justify-start gap-2 sm:gap-4">
          {user.role && user.role.toLowerCase().includes('leader') && ALLOW_DROPDOWN ? (
            <div className="flex items-center space-x-3">
              <label className="text-sm font-medium text-gray-700">Leader:</label>
              <select
                value={selectedLeaderId || ''}
                onChange={handleLeaderChange}
                className="p-2 border border-gray-300 rounded-lg text-sm bg-white"
              >
                <option value="">Select leader...</option>
                {leaders.map(l => (
                  <option key={l.account_id} value={l.account_id}>
                    {`${l.display_name || `${l.first_name} ${l.last_name}`} (ID: ${l.account_id})`}
                  </option>
                ))}
              </select>
            </div>
          ) : (
            <span className="text-sm font-medium text-gray-700 break-words">Logged in as: <strong className="text-indigo-700">{user.name}</strong> ({user.role})</span>
          )}

          <button
            onClick={handleLogout}
            className="text-sm font-semibold text-red-600 hover:text-red-800 transition flex items-center"
          >
            <FiLogOut size={16} className="rotate-180 mr-1 inline-block" /> Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
